import React from 'react';
import { motion } from 'framer-motion';
import { GiftIcon, FileTextIcon, BookOpenIcon, TrendingUpIcon } from 'lucide-react';
export function BonusesSection() {
  const scrollToCompra = () => {
    document.getElementById('compra')?.scrollIntoView({
      behavior: 'smooth'
    });
  };
  const bonuses = [{
    icon: FileTextIcon,
    title: 'Plantillas de Evaluación',
    description: 'Formularios listos para usar en cada primera consulta'
  }, {
    icon: BookOpenIcon,
    title: 'Casos Clínicos Resueltos',
    description: '10 casos reales con protocolos aplicados'
  }, {
    icon: TrendingUpIcon,
    title: 'Sistema de Seguimiento',
    description: 'Planillas para trackear progreso de pacientes'
  }];
  return <section className="w-full px-4 py-20 bg-[#0f172a]" data-id="element-35">
      <div className="max-w-6xl mx-auto" data-id="element-36">
        <motion.div initial={{
        opacity: 0,
        y: 30
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.6
      }} className="text-center mb-12" data-id="element-37">
          <div className="inline-block bg-yellow-400/90 text-black px-6 py-2 rounded-full font-bold text-sm mb-6" data-id="element-38">
            BONOS EXCLUSIVOS
          </div>
          <h2 className="text-3xl md:text-5xl font-black mb-4 flex items-center justify-center gap-3" data-id="element-39">
            <GiftIcon className="w-10 h-10 text-yellow-400" data-id="element-40" />
            GRATIS POR EL DÍA DE HOY
          </h2>
          <p className="text-xl text-gray-400" data-id="element-41">
            Recursos adicionales para acelerar tu transformación
          </p>
        </motion.div>

        <div className="grid md:grid-cols-3 gap-6" data-id="element-42">
          {bonuses.map((bonus, index) => <motion.div key={index} initial={{
          opacity: 0,
          y: 30
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.4,
          delay: 0.1 * index
        }} onClick={scrollToCompra} className="bg-gradient-to-br from-yellow-400/20 to-yellow-400/5 border-2 border-yellow-400 p-6 rounded-xl cursor-pointer hover:shadow-lg hover:shadow-yellow-400/20 transition-all" data-id="element-43">
              <div className="flex items-start gap-4" data-id="element-44">
                <div className="bg-yellow-400/90 p-3 rounded-lg" data-id="element-45">
                  <bonus.icon className="w-6 h-6 text-black" data-id="element-46" />
                </div>
                <div className="flex-1" data-id="element-47">
                  <h3 className="text-xl font-bold mb-2 text-white" data-id="element-48">
                    {bonus.title}
                  </h3>
                  <p className="text-gray-300" data-id="element-49">{bonus.description}</p>
                  <div className="mt-3 inline-block bg-yellow-400/20 text-yellow-400 px-3 py-1 rounded text-sm font-semibold" data-id="element-50">
                    GRATIS HOY
                  </div>
                </div>
              </div>
            </motion.div>)}
        </div>
      </div>
    </section>;
}